import { css, styled } from 'styled-components';

import HeadingLevelOne from '../HeadingLevelOne';

const TitleSectionHeading = styled(HeadingLevelOne)`
    ${({ theme }: any) => css`
        max-width: 90%;
        margin: auto;
        color: ${theme.colors.global.black};
        ${theme.components.BodyWidth}
        ${theme.components.TitleSectionHeading}
    `}
`;

export default TitleSectionHeading;
